import { IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonSegment, IonSegmentButton, IonLabel } from '@ionic/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { achievementCategories } from '@/data/achievements';
import { AchievementCategory } from '@/components/achievements/AchievementCategory';

const Achievements: React.FC = () => {
  const { t } = useTranslation('MGP');
  const [activeSegment, setActiveSegment] = useState<string>('all');

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/profile" text="" />
          </IonButtons>
          <IonTitle className="font-medium">{t('achievements', 'Mes trophées')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <div className="bg-warning p-4 rounded-lg mb-6 text-sm">
          <span>{t('achievements_warning', 'Les trophées seront prochainement disponibles. Les actions effectuées aujourd\'hui seront comptabilisées dans une prochaine version.')}</span>
        </div>
        <div className="flex flex-col space-y-6">
          <IonSegment value={activeSegment} onIonChange={e => setActiveSegment(e.detail.value as string)} className="mb-6">
            <IonSegmentButton value="all">
              <IonLabel>{t('all', 'Tous')}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="not_earned">
              <IonLabel>{t('not_earned', 'Pas encore gagnés')}</IonLabel>
            </IonSegmentButton>
          </IonSegment>

          <div className="mt-4">
            {activeSegment === 'all' && (
              <div>
                {achievementCategories.map((category) => (
                  <AchievementCategory
                    key={category.id}
                    title={t(category.titleKey, category.defaultTitle)}
                    achievements={category.achievements}
                  />
                ))}
              </div>
            )}

            {activeSegment === 'not_earned' && (
              <div>
                {achievementCategories.map((category) => (
                  <AchievementCategory
                    key={category.id}
                    title={t(category.titleKey, category.defaultTitle)}
                    achievements={category.achievements.filter(a => !a.earned)}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Achievements;
